import { heroCovers, siteStats } from "@/mocks/home";

export default function HeroCovers() {
  const [main, ...side] = heroCovers;

  return (
    <section id="top" className="w-full px-4 pb-12 pt-8 md:px-8 md:pb-16 md:pt-12">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3 border-b border-background-200 pb-4">
        <div className="flex items-center gap-3">
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-bookmark-3-fill text-xs" />
          </span>
          <span className="font-heading text-sm font-semibold tracking-wide text-foreground-900 md:text-base">
            封面导读 · 多卡并列首屏
          </span>
        </div>
        <span className="font-label text-xs uppercase tracking-[0.3em] text-foreground-500">
          Cover Desk / 04 Picks
        </span>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
        {/* 主封面 */}
        <article className="group relative h-[420px] overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-[560px] lg:col-span-7 lg:h-[640px]">
          <img
            src={main.image}
            alt="黑料每日今日头条封面图"
            title="黑料每日今日头条 - 热度排行与讨论最多爆料"
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/10" />
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                {main.tag}
              </span>
              <span className="rounded-full border border-background-50/40 px-3 py-1 text-xs text-background-50">
                {main.time}
              </span>
            </div>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-white md:text-3xl">
              <a href="#headlines" className="transition-colors hover:text-accent-300">
                {main.title}
              </a>
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              {main.excerpt}
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-5 text-sm">
              <span className="flex items-center gap-2 font-label text-accent-400">
                <i className="ri-fire-fill" />
                <span className="text-lg font-semibold">{main.heat}</span>
                <span className="text-xs text-background-300">热度</span>
              </span>
              <span className="flex items-center gap-2 font-label text-background-100">
                <i className="ri-chat-3-line" />
                <span className="text-lg font-semibold">{main.discussion}</span>
                <span className="text-xs text-background-300">讨论</span>
              </span>
            </div>
          </div>
        </article>

        {/* 副封面并列 */}
        <div className="flex flex-col gap-5 lg:col-span-5">
          {side.map((card) => (
            <article
              key={card.id}
              className="group flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-4"
            >
              <div className="h-24 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-28">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`${card.tag} - ${card.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
                      {card.tag}
                    </span>
                    <span className="text-[11px] text-foreground-500">{card.time}</span>
                  </div>
                  <h3 className="mt-2 font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                    <a href="#headlines" className="transition-colors hover:text-primary-600">
                      {card.title}
                    </a>
                  </h3>
                </div>
                <div className="mt-2 flex items-center gap-4 text-xs text-foreground-600">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fire-line text-primary-500" />
                    {card.heat}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-foreground-400" />
                    {card.discussion}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* 数据条 */}
      <div className="mt-8 grid grid-cols-2 gap-4 border-y border-background-200 py-6 md:mt-10 md:grid-cols-4">
        {siteStats.map((stat) => (
          <div key={stat.label} className="flex flex-col items-center text-center">
            <div className="flex items-baseline gap-1">
              <span className="font-label text-3xl font-semibold text-primary-600 md:text-4xl">{stat.value}</span>
              <span className="text-sm text-foreground-600">{stat.unit}</span>
            </div>
            <span className="mt-1 text-xs tracking-wide text-foreground-500">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}